export enum TrainingAppSubscriptionSourceType {
	ByRandUNo = 1,
	ByRandUYes = 2,
	Manual = 3
}